/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames';
import React from 'react';
import Icon from 'images/v5/icons/check.svg';
import LoaderSvg from 'images/v5/icons/loader.svg';
import styles from './Checkbox.module.scss';
function Checkbox({ label, name, value = false, size = 'm', disabled, loading, testId, onClick, }) {
    const wrapClasses = classNames(styles.wrap, styles[size], {
        [styles.disabled]: disabled,
        [styles.loading]: loading,
    });
    const boxClasses = classNames(styles.box, styles[size], {
        [styles.checked]: value,
        [styles.disabled]: disabled,
    });
    return (React.createElement("div", { className: wrapClasses, onClick: loading ? undefined : onClick, "data-test": testId },
        React.createElement("input", { type: "checkbox", name: name, checked: value, onChange: () => { } }),
        React.createElement("div", { className: boxClasses },
            React.createElement(Icon, null),
            loading && (React.createElement("span", { className: styles.loaderOverlay },
                React.createElement(LoaderSvg, null)))),
        label && React.createElement("p", null, label)));
}
export default Checkbox;
